import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';
import { Link } from 'react-router-dom';

export type PublicInfoPageProps = {};

const PublicInfoPage: React.FC<PublicInfoPageProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'}
        heading={
          intl.formatMessage({id: 'public-info'})
        }
      />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-10">
        <div className="w-full flex flex-col gap-4">
          <h2 className="text-2xl text-secondary font-bold uppercase">
            {
              intl.formatMessage({
                id: "public-info"
              })
            }
          </h2>
          <p>
            {
              intl.formatMessage({
                id: "public_info_1"
              })
            }
          </p>
          <p>
            {
              intl.formatMessage({
                id: "public_info_2"
              })
            }
          </p>
          <div className="flex flex-row gap-4 items-center">
            <img src="/icons/callus.svg" alt="Phone" />
            <a href="tel:55 5801 5763">55 5801 5763</a>
          </div>
          <div className="flex flex-row gap-4 items-center">
            <img src="/icons/mailus.svg" alt="Email" />
            <a href="mailto:contacto@mexicocb.com.mx">contacto@mexicocb.com.mx</a>
          </div>
          <div className="w-full flex flex-col md:flex-row gap-6 items-center justify-between mt-10">
            <Link to="/general-info/public-info/electronic-security" className="flex flex-col gap-3 items-center justify-center">
              <img src="/icons/elect-secure.svg" alt="" />
              <p className="h-14 text-center flex items-center justify-center">
                {
                  intl.formatMessage({
                    id: "public_info_3"
                  })
                }
              </p>
            </Link>
            <Link to="/general-info/public-info/telecommunications" className="flex flex-col gap-3 items-center justify-center">
              <img src="/icons/energy-eff.svg" alt="" />
              <p className="h-14 text-center flex items-center justify-center">
                {
                  intl.formatMessage({
                    id: "public_info_5"
                  })
                }
              </p>
            </Link>
            <Link to="/general-info/public-info/energy-efficiency" className="flex flex-col gap-3 items-center justify-center">
              <img src="/icons/telehome.svg" alt="" />
              <p className="h-14 text-center flex items-center justify-center">
                {
                  intl.formatMessage({
                    id: "public_info_4"
                  })
                }
              </p>
            </Link>
            <Link to="/general-info/public-info/list-of-labs" className="flex flex-col gap-3 items-center justify-center">
              <img src="/icons/lablist.svg" alt="" />
              <p className="h-14 text-center flex items-center justify-center">
                {
                  intl.formatMessage({
                    id: "public_info_6"
                  })
                }
              </p>
            </Link>
            <Link to="/general-info/public-info/legal-list" className="flex flex-col gap-3 items-center justify-center">
              <img className='h-[145px] w-[140px]' src="/img/legal_logo.png" alt="" />
              <p className="h-14 text-center flex items-center justify-center">
                {
                  intl.formatMessage({
                    id: "public_info_7"
                  })
                }
              </p>
            </Link>
            <Link to="/general-info/public-info/customs" className="flex flex-col gap-3 items-center justify-center">
              <img className='h-[145px] w-[140px]' src="/img/customs_logo.png" alt="" />
              <p className="h-14 text-center flex items-center justify-center">
                {
                  intl.formatMessage({
                    id: "public_info_8"
                  })
                }
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PublicInfoPage;